var _rect, _rect2, _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypeSteeringWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#C2C2C2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.0002,
    cy: 14.4673,
    rx: 2.64762,
    ry: 2.66061,
    fill: "#FFC300"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7732 4.22454C8.13408 5.0099 4.98637 8.20216 4.2195 11.8848C2.7387 18.9967 8.97883 25.2675 16.0561 23.7794C18.8543 23.191 21.5176 21.1354 22.7891 18.5825C23.1405 17.8771 23.5099 16.8914 23.61 16.3922C23.7102 15.8929 23.8563 15.3622 23.9344 15.2127C24.1 14.8966 23.8903 12.3747 23.9676 12.6675C23.9676 12.5892 23.7681 12.3148 23.6593 11.7735C23.5504 11.2321 23.1685 10.1929 22.8105 9.46423C20.8408 5.45531 16.2244 3.26391 11.7732 4.22454ZM12.3153 6.07931C10.238 6.55587 8.58916 7.64876 7.41704 9.32619C6.67883 10.3823 6.20054 11.4234 6.37357 11.5973C6.41889 11.6428 6.96897 11.5624 7.59615 11.4184C11.6095 10.4973 16.2976 10.4973 20.3109 11.4184C20.9381 11.5624 21.4882 11.6428 21.5335 11.5973C21.7069 11.4231 21.2275 10.3812 20.4848 9.31853C18.6909 6.7515 15.28 5.39913 12.3153 6.07931ZM12.6121 13.103C11.27 14.3391 12.1228 16.4972 13.9535 16.4972C14.6874 16.4972 15.1942 16.2152 15.6368 15.5603C16.1811 14.7556 16.0477 13.7962 15.295 13.103C14.8189 12.6645 14.6218 12.589 13.9535 12.589C13.2853 12.589 13.0882 12.6645 12.6121 13.103ZM4.12469 13.9978C4.12469 14.7295 4.06734 15.0287 4.10004 14.6628C4.13291 14.2968 4.13291 13.6982 4.10004 13.3325C4.06734 12.9665 4.12469 13.2661 4.12469 13.9978ZM6.26922 16.3843C6.57167 17.4118 6.67088 17.6046 7.51547 18.8057C8.43217 20.1089 10.0341 21.2619 11.5953 21.7419C11.958 21.8535 11.9611 21.8447 11.8499 21.0172C11.6149 19.2669 10.7222 17.6633 9.46303 16.7293C8.73789 16.1914 7.08282 15.5627 6.3921 15.5627H6.02751L6.26922 16.3843ZM20.1691 15.8594C17.9276 16.5801 16.3978 18.4994 16.0578 21.0172C15.946 21.8449 15.9489 21.8535 16.3118 21.7419C17.873 21.2619 19.4749 20.1089 20.3916 18.8057C21.2362 17.6046 21.3354 17.4118 21.6379 16.3843L21.8796 15.5627L21.4597 15.5711C21.2287 15.5757 20.648 15.7056 20.1691 15.8594Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeSteeringWarning);
export default __webpack_public_path__ + "static/media/Type=SteeringWarning.639c2fb5bfca47115bd0d4da0f733ac6.svg";
export { ForwardRef as ReactComponent };